export const SET_ID = 'setId';
export const SET_MAIN = 'setMain';
export const FETCH_ITEM = 'fetchItem';
export const SET_FOOTER = 'setFooter';
export const SET_SIDEBAR = 'setSidebar';
export const STORE_MODULE_NAME = 'module';
export const SET_NOTHING_FOUND = 'setNothingFound';
export const SET_PROFESSION_ID = 'setProfessionId';



// WEBPACK FOOTER //
// ./src/pages/modules/card/consts.ts